module.exports = __webpack_public_path__ + "img/AI_10.543fb163.png";